import { React, useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import AgentLayout from "../components/AgentLayout";
import { useDispatch, useSelector } from "react-redux";
import { NumericFormat } from 'react-number-format'; // Updated import

import useSocket from "../../../hooks/useSocket";
import moment from "moment";
import axiosInstance from "../../../utils/axiosInstance";


import MarketAnalysisRight from "./right-side";
import MarketAnalysisMatchOdd from "./match-odds";
import MarketAnalysisToss from "./toss";
import MarketAnalysisBookmaker from "./bookmaker";
import MarketAnalysisBetfairFancy from "./betfair-fancy";
import MarketAnalysisFancy from "./fancy";
import MarketAnalysisTie from "./tie";
import MarketAnalysisFigure from "./figure";
import MarketAnalysisEvenOdd from "./even_odd";
import MarketAnalysisFootballFancy from "./football-fancy";
import HrGrMatchOdd from "../markets/hr-gr-match-odd";
import { setUserData } from "../../../store/userSlice";

const MarketAnalysis = () => {
  let matchOdds = null;
  let bookmakerOdds = null;
  let tossData = null;
  let fancyData = null;
  let fancyBookData = null;
  let betsData = null;
  let betfairFancyData = null;
  let betfairFancyOddsData = null;
  let tieData = null;
  let evenodddata = null;
  let figuredata = null;
  let footballFancy = null;
  let footballFancyBook = null;
  let scoreboardData = null;

  let toss = null;
  let inplay = false;
  let is_bm_on = false;
  let fancy = false;
  let tie = false;
  let betfairfancy = false;
  let figure = false;
  let evenodd = false;
  let game_type = 0;
  let tie_cat_mid = "";

  const dispatch = useDispatch();

  const { marketId } = useParams();
  const [eventDetails, setEventDetails] = useState({});
  const [eventStatus, setEventStatus] = useState("");
  const [GameType, setGameType] = useState(0);
  const [timeLeft, setTimeLeft] = useState("");
  const [activeMarketList] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [timeLeftInHour, setTimeLeftInHour] = useState("");
  const [HRGRBook, setHRGRBook] = useState([]);

  let bookData = null;
  let bookmarkData = null;
  let tieBookData = null;
  let hrgrBookData = HRGRBook;

  const getHRGRBook = async (marketId) => {
    try {
      const response = await axiosInstance.post(
        "/markets/hr-gr-book/" + marketId,
        { market_type: 1 }
      );
      if (
        response.data !== null &&
        response.data.book_list !== null &&
        response.data.book_list !== undefined
      ) {
        setHRGRBook(response.data.book_list);
      }
    } catch (error) {
      console.error("Error fetching HR/GR book:", error);
    }
  };

  const fetchEventsById = async (marketId) => {
    //console.log("Fetching Single event...");
    try {
      //ShowHideLoader(true);

      const response = await axiosInstance.get("/events/" + marketId);
      if (
        response.data !== null &&
        response.data.event !== null &&
        response.data.event !== undefined
      ) {
        setPageDisplaySetting(response.data.event[0]);
        let eventDetails = response.data.event[0];

        if (
          eventDetails !== null &&
          (Number(eventDetails.game_type) === 4 ||
            Number(eventDetails.game_type) === 5)
        ) {
          getHRGRBook(marketId);
        }

        if (
          eventDetails !== null &&
          (eventDetails.game_type == 1 ||
            eventDetails.game_type == 2 ||
            eventDetails.game_type == 3)
        ) {
          //getUserBookMatchOdd(marketId);
        }

        if (eventDetails !== null && eventDetails.game_type === 1) {
          //getBookForBookMaker(marketId);
        }

        if (eventDetails !== null && eventDetails.game_type === 2) {
          //getUserFootballFancyBook(marketId);
        }

        //getBetList(marketId);
      }
      //console.log(response.data); // single event data
    } catch (error) {
      console.error("Error fetching single event:", error);
    }
  };

  const timeRemaining = (eventDate) => {
    //useEffect(() => {
    const interval = setInterval(() => {
      const startDate = moment(); // current time
      const endDate = moment(eventDate); // your target date

      const duration = moment.duration(endDate.diff(startDate));

      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      if (minutes < 0) {
        const startDate = moment(eventDate); // your target date
        const endDate = moment(); // current time
        const duration = moment.duration(endDate.diff(startDate));
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        setTimeLeft(`${"Elapsed"}: ${hours}:${minutes}:${seconds}`);
        setTimeLeftInHour(`${"in"} ${hours} ${"hours"}`);
      } else {
        setTimeLeft(`${"Remaining"}: ${hours}:${minutes}:${seconds}`);
        setTimeLeftInHour(`${"in"} ${hours} ${"hours ago"}`);
      }
    }, 1000);

    return () => clearInterval(interval); // cleanup on unmount
    // }, []);
  };

  const setPageDisplaySetting = (eventData) => {
    if (eventData !== undefined) {
      setEventDetails(eventData);
      setEventStatus(eventData.evt_status);
      setGameType(eventData.game_type);
      timeRemaining(eventData.evt_od);
    }
  };

  //Get Event Details By CatMid
  useEffect(() => {
    fetchEventsById(marketId);
  }, []); // Empty dependency array

  const { data, isConnected } = useSocket({
    marketId: marketId,
    mtype: "sports",
    type: ""
  });

  if (data !== null && data.data !== null && data.data !== undefined) {
    console.log("Received Socket Data->", data);
    if (data?.user !== null && data?.user !== undefined) {
      //dispatch(setUserData(data.user));
    }
    if (data?.book) {
      bookData = data?.book[0];
    }
    if (data?.bookmark) {
      bookmarkData = data?.bookmark[0];
    }
    if (data?.tieBook) {
      tieBookData = data?.tieBook[0];
    }
    if (data?.hrgrBook) {
      hrgrBookData = data.hrgrBook;
    }
    if (data.data.odds !== null && data.data.odds !== undefined) {
      matchOdds = data.data.odds;

      inplay = matchOdds.inplay;
      is_bm_on = matchOdds.is_bm_on;
      fancy = matchOdds.fancy;
      toss = matchOdds.toss_on;
      tie = matchOdds.tie_on;
      betfairfancy = matchOdds.bf_fancy_on;
      figure = matchOdds.figure;
      evenodd = matchOdds.evenodd;
      game_type = matchOdds.game_type;
      tie_cat_mid = matchOdds.tie_cat_mid;

      //fancy on/off
      if (!fancy) {
        let findFancyIndex = activeMarketList.indexOf("fancy2");
        if (findFancyIndex >= 0) {
          activeMarketList.splice(findFancyIndex, 1);
        }
      } else {
        let findFancyIndex = activeMarketList.indexOf("fancy2");
        if (findFancyIndex < 0) {
          activeMarketList.push("fancy2");
        }
      }

      //betfair fancy on/off

      if (betfairfancy !== "0") {
        if (!betfairfancy) {
          let findBFFancyIndex = activeMarketList.indexOf("fancy");
          if (findBFFancyIndex >= 0) {
            activeMarketList.splice(findBFFancyIndex, 1);
          }
        } else {
          let findBFFancyIndex = activeMarketList.indexOf("fancy");
          if (findBFFancyIndex < 0) {
            activeMarketList.push("fancy");
          }
        }
      }

      //toss on/off
      if (inplay) {
        let findTossIndex = activeMarketList.indexOf("toss");
        if (findTossIndex >= 0) {
          activeMarketList.splice(findTossIndex, 1);
        }
      } else {
        if (!toss) {
          let findTossIndex = activeMarketList.indexOf("toss");
          if (findTossIndex >= 0) {
            activeMarketList.splice(findTossIndex, 1);
          }
        } else {
          let findTossIndex = activeMarketList.indexOf("toss");
          if (findTossIndex < 0) {
            activeMarketList.push("toss");
          }
        }
      }

      //bookmaker on/off
      if (!is_bm_on) {
        let findBookmakerIndex = activeMarketList.indexOf("bookmaker");
        if (findBookmakerIndex >= 0) {
          activeMarketList.splice(findBookmakerIndex, 1);
        }
      } else {
        let findBookmakerIndex = activeMarketList.indexOf("bookmaker");
        if (findBookmakerIndex < 0) {
          activeMarketList.push("bookmaker");
        }
      }

      //tie on/off
      if (!tie) {
        let findTieIndex = activeMarketList.indexOf("tie");
        if (findTieIndex >= 0) {
          activeMarketList.splice(findTieIndex, 1);
        }
      } else {
        let findTieIndex = activeMarketList.indexOf("tie");
        if (findTieIndex < 0) {
          activeMarketList.push("tie");
        }
      }

      //evenodd
      if (!evenodd) {
        let findEvenOddIndex = activeMarketList.indexOf("even_odd");
        if (findEvenOddIndex >= 0) {
          activeMarketList.splice(findEvenOddIndex, 1);
        }
      } else {
        let findEvenOddIndex = activeMarketList.indexOf("even_odd");
        if (findEvenOddIndex < 0) {
          activeMarketList.push("even_odd");
        }
      }

      //figure
      /*if (!figure) {
        let findFigureIndex = activeMarketList.indexOf("other");
        if (findFigureIndex >= 0) {
          activeMarketList.splice(findFigureIndex, 1);
        }
      } else {
        let findFigureIndex = activeMarketList.indexOf("other");
        if (findFigureIndex < 0) {
          activeMarketList.push("other");
        }
      }*/

      //console.log("activeMarketList->", activeMarketList);
    }

    if (data.data.bookmaker !== null && data.data.bookmaker !== undefined) {
      bookmakerOdds = data.data.bookmaker;
    }

    if (
      data.data.betfairFancy !== null &&
      data.data.betfairFancy !== undefined
    ) {
      betfairFancyData = data.data.betfairFancy;
    }

    if (inplay === 0) {
      if (data.data.toss !== null && data.data.toss !== undefined) {
        tossData = data.data.toss;
      }
    }

    if (data.data.fancy !== null && data.data.fancy !== undefined) {
      fancyData = data.data.fancy;
    }

    if (data.bets !== null && data.bets !== undefined) {
      betsData = data.bets;
    } else {
      console.log("betsData not found....", data);
    }

    if (data.fancyBookData !== null && data.fancyBookData !== undefined) {
      fancyBookData = data.fancyBookData;
    }

    if (data.betfairFancyData !== null && data.betfairFancyData !== undefined) {
      betfairFancyOddsData = data.betfairFancyData;
    }

    if (
      data.footballFancyBook !== null &&
      data.footballFancyBook !== undefined
    ) {
      footballFancyBook = data.footballFancyBook;
    }

    if (inplay === 1) {
      if (data.data.tiedds !== null && data.data.tiedds !== undefined) {
        tieData = data.data.tiedds;
      } else {
        //console.log("tieData not found....",tieData);
      }

      if (
        data.data.evenodddata !== null &&
        data.data.evenodddata !== undefined
      ) {
        evenodddata = data.data.evenodddata;
      }

      if (data.data.figuredata !== null && data.data.figuredata !== undefined) {
        figuredata = data.data.figuredata;
      }

      if (
        data.data.footballFancy !== null &&
        data.data.footballFancy !== undefined
      ) {
        footballFancy = data.data.footballFancy;
      }

      if (
        data.data.fancyScoreBoard !== null &&
        data.data.fancyScoreBoard !== undefined
      ) {
        scoreboardData = data.data.fancyScoreBoard;
      }
    }
  }

  return (
    <AgentLayout>
      <div className="right-side-wrapper-row" style={{ background: "#e4e5e6" }}>
        <div className="row right-side-row">
          <div
            className="col-md-8 padding-none-wrapper1"
            style={{ marginTop: "10px" }}
          >
            <div className="left-content">
              <div className="table-wrap">
                <div className="details-tabs-wrapper1">
                  <div className="tab-content">
                    <div className="tab-pane active" style={{ padding: "0px" }}>
                      <div
                        style={{
                          display:
                            (activeTab === "all" || activeTab == "") &&
                              (GameType === 4 || GameType === 5)
                              ? "block"
                              : "none"
                        }}
                      >
                        {GameType === 4 || GameType === 5 ? (
                          <HrGrMatchOdd
                            eventDetails={eventDetails}
                            matchOdds={matchOdds}
                            HRGRBook={hrgrBookData}
                          ></HrGrMatchOdd>
                        ) : (
                          ""
                        )}
                      </div>

                      {activeTab === "all" &&
                        GameType !== 4 &&
                        GameType !== 5 ? (
                        <div
                          className="table-box-body"
                          style={{ background: "transparent" }}
                        >
                          <MarketAnalysisMatchOdd
                            eventDetails={eventDetails}
                            matchOdds={matchOdds}
                            bookData={bookData}
                            scoreboardData={scoreboardData}
                            timeLeft={timeLeft}
                          ></MarketAnalysisMatchOdd>
                        </div>
                      ) : (
                        ""
                      )}
                      <audio id="myAudio">
                        <source id="audio_src" src="" type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                      {activeMarketList.includes("toss") &&
                        GameType === 1 &&
                        toss === 1 &&
                        inplay === 0 ? (
                        <div
                          className="table-box-body"
                          style={{
                            background: "transparent",
                            display:
                              activeTab === "all" || activeTab === "toss"
                                ? "block"
                                : "none"
                          }}
                        >
                          <MarketAnalysisToss
                            tossData={tossData}
                          ></MarketAnalysisToss>
                        </div>
                      ) : (
                        ""
                      )}
                      {activeMarketList.includes("bookmaker") &&
                        GameType === 1 &&
                        is_bm_on === 1 ? (
                        <div
                          className="table-box-body"
                          style={{
                            background: "transparent",
                            display:
                              activeTab === "all" || activeTab === "bookmaker"
                                ? "block"
                                : "none"
                          }}
                        >
                          <MarketAnalysisBookmaker
                            eventDetails={eventDetails}
                            bookmakerOdds={bookmakerOdds}
                            bookmarkData={bookmarkData}
                          ></MarketAnalysisBookmaker>
                        </div>
                      ) : (
                        ""
                      )}

                      {GameType === 1 ? (
                        <div
                          className="table-box-body"
                          style={{
                            background: "transparent",
                            display:
                              activeTab === "all" || activeTab === "fancy"
                                ? "block"
                                : "none"
                          }}
                        >
                          <MarketAnalysisBetfairFancy
                            eventDetails={eventDetails}
                            betfairFancyData={betfairFancyData}
                            betfairFancyOddsData={betfairFancyOddsData}
                          ></MarketAnalysisBetfairFancy>
                        </div>
                      ) : (
                        ""
                      )}

                      {activeMarketList.includes("fancy2") &&
                        GameType === 1 &&
                        fancy === 1 ? (
                        <div
                          className="table-box-body"
                          style={{
                            background: "transparent",
                            display:
                              activeTab === "all" || activeTab === "fancy2"
                                ? "block"
                                : "none"
                          }}
                        >
                          <MarketAnalysisFancy
                            eventDetails={eventDetails}
                            fancyData={fancyData}
                            fancyBookData={fancyBookData}
                          ></MarketAnalysisFancy>
                        </div>
                      ) : (
                        ""
                      )}
                      {activeMarketList.includes("tie") &&
                        GameType === 1 &&
                        tie === 1 ? (
                        <div
                          className="table-box-body"
                          style={{
                            background: "transparent",
                            display:
                              activeTab === "all" || activeTab === "tie"
                                ? "block"
                                : "none"
                          }}
                        >
                          <MarketAnalysisTie
                            tieData={tieData}
                            tieBookData={tieBookData}
                          ></MarketAnalysisTie>
                        </div>
                      ) : (
                        ""
                      )}
                      {GameType === 1 && figure == 1 ? (
                        <div
                          className="table-box-body"
                          style={{
                            background: "transparent"
                          }}
                        >
                          <MarketAnalysisFigure
                            figuredata={figuredata}
                          ></MarketAnalysisFigure>
                        </div>
                      ) : (
                        ""
                      )}

                      {activeMarketList.includes("even_odd") &&
                        GameType === 1 &&
                        evenodd == 1 ? (
                        <div
                          className="table-box-body"
                          style={{
                            background: "transparent",
                            display:
                              activeTab === "all" || activeTab === "even_odd"
                                ? "block"
                                : "none"
                          }}
                        >
                          <MarketAnalysisEvenOdd
                            eventDetails={eventDetails}
                            evenodddata={evenodddata}
                          ></MarketAnalysisEvenOdd>
                        </div>
                      ) : (
                        ""
                      )}
                      {activeMarketList.includes("fancy2") && GameType === 2 ? (
                        <div
                          className="table-box-body"
                          style={{
                            background: "transparent",
                            display:
                              activeTab === "all" || activeTab === "fancy2"
                                ? "block"
                                : "none"
                          }}
                        >
                          <MarketAnalysisFootballFancy
                            footballFancy={footballFancy}
                            footballFancyBook={footballFancyBook}
                          ></MarketAnalysisFootballFancy>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 padding-none-wrapper mobTop">
            <MarketAnalysisRight
              eventDetails={eventDetails}
              betsData={betsData}
            ></MarketAnalysisRight>
          </div>
        </div>
      </div>
    </AgentLayout>
  );
};

export default MarketAnalysis;